export default __webpack_public_path__ + "static/the_square-dcd5e42e71ab6c8887c9b845bfb8a329.png";